import { formatDistanceToNow } from "date-fns";
import type { FC } from "react";
import { smallTimestampStyle } from "../timestamps/styles.js";

interface SmallTimeStampProps {
  timestamp: string;
  className?: string;
}

export const SmallTimeStamp: FC<SmallTimeStampProps> = ({
  timestamp,
  className,
}) => {
  const timeAgo = formatDistanceToNow(new Date(timestamp), {
    addSuffix: true,
  })
    .replace(/about /, "")
    .replace(
      /(\d+) (second|minute|hour|day|month|year)s? ago/,
      (_, num, unit) =>
        // oxlint-disable-next-line typescript/no-unsafe-member-access
        `${num}${unit === "month" ? "mo" : unit === "hour" ? "h" : unit[0]} ago`,
    );

  return (
    <span className={smallTimestampStyle({ className })}>
      {timeAgo === "less than a minute ago" ? "1m ago" : timeAgo}
    </span>
  );
};
